var map = {
	"./amblems/left/France/Fake_Bordeaux.png": 2029,
	"./amblems/left/France/Fake_Lille.png": 2030,
	"./amblems/left/France/Fake_Lyon.png": 2031,
	"./amblems/left/France/Fake_Marseille.png": 2032,
	"./amblems/left/France/Fake_PSG.png": 2033,
	"./amblems/left/Germany/Fake_Bayern.png": 2034,
	"./amblems/left/Germany/Fake_Dortmund.png": 2035,
	"./amblems/left/Germany/Fake_Hertha.png": 2036,
	"./amblems/left/Germany/Fake_Leverkusen.png": 2037,
	"./amblems/left/Germany/Fake_Schalke.png": 2038,
	"./amblems/left/Italy/Fake_Inter.png": 2039,
	"./amblems/left/Italy/Fake_Juventus.png": 2040,
	"./amblems/left/Italy/Fake_Lazio.png": 2041,
	"./amblems/left/Italy/Fake_Milan.png": 2042,
	"./amblems/left/Italy/Fake_Roma.png": 2043,
	"./amblems/left/Spain/Fake_AtleticoBilbao.png": 2044,
	"./amblems/left/Spain/Fake_AtleticoMadrid.png": 2045,
	"./amblems/left/Spain/Fake_Barcelona.png": 2046,
	"./amblems/left/Spain/Fake_RealMadrid.png": 2047,
	"./amblems/left/Spain/Fake_Valencia.png": 2048,
	"./amblems/left/logos/ALAVES.png": 2049,
	"./amblems/left/logos/Arsenal.png": 2050,
	"./amblems/left/logos/AtleticoBilbao.png": 2051,
	"./amblems/left/logos/AtleticoMadrid.png": 2052,
	"./amblems/left/logos/Atm.png": 2053,
	"./amblems/left/logos/BILBAO.png": 2054,
	"./amblems/left/logos/Barcelona.png": 2055,
	"./amblems/left/logos/Bayern.png": 2056,
	"./amblems/left/logos/Bordeaux.png": 2057,
	"./amblems/left/logos/Bournmouth.png": 2058,
	"./amblems/left/logos/BrightHoveAlbion.png": 2059,
	"./amblems/left/logos/Broomwich.png": 2060,
	"./amblems/left/logos/Burnley.png": 2061,
	"./amblems/left/logos/Cev.png": 2062,
	"./amblems/left/logos/Chelsea.png": 2063,
	"./amblems/left/logos/CrystalPalace.png": 2064,
	"./amblems/left/logos/Dortmund.png": 2065,
	"./amblems/left/logos/EIBAR.png": 2066,
	"./amblems/left/logos/Esp.png": 2067,
	"./amblems/left/logos/Everton.png": 2068,
	"./amblems/left/logos/FakeAstonVilla.png": 2069,
	"./amblems/left/logos/FakeCardiffCity.png": 2070,
	"./amblems/left/logos/FakeFulham.png": 2071,
	"./amblems/left/logos/FakeNorwichCity.png": 2072,
	"./amblems/left/logos/FakeSheffield.png": 2073,
	"./amblems/left/logos/FakeWolverhampton.png": 2074,
	"./amblems/left/logos/Fake_Arsenal.png": 2075,
	"./amblems/left/logos/Fake_Bournmouth.png": 2076,
	"./amblems/left/logos/Fake_BrightHoveAlbion.png": 2077,
	"./amblems/left/logos/Fake_Broomwich.png": 2078,
	"./amblems/left/logos/Fake_Burnley.png": 2079,
	"./amblems/left/logos/Fake_Chelsea.png": 2080,
	"./amblems/left/logos/Fake_CrystalPalace.png": 2081,
	"./amblems/left/logos/Fake_Everton.png": 2082,
	"./amblems/left/logos/Fake_Huddersfield.png": 2083,
	"./amblems/left/logos/Fake_Leicester.png": 2084,
	"./amblems/left/logos/Fake_Liverpool.png": 2085,
	"./amblems/left/logos/Fake_Manchester.png": 2086,
	"./amblems/left/logos/Fake_ManchesterCity.png": 2087,
	"./amblems/left/logos/Fake_NewCastle.png": 2088,
	"./amblems/left/logos/Fake_Southampton.png": 2089,
	"./amblems/left/logos/Fake_StrokeCity.png": 2090,
	"./amblems/left/logos/Fake_SwanCity.png": 2091,
	"./amblems/left/logos/Fake_TottenhamHotspur.png": 2092,
	"./amblems/left/logos/Fake_Watford.png": 2093,
	"./amblems/left/logos/Fake_WestHamUtd.png": 2094,
	"./amblems/left/logos/Get.png": 2095,
	"./amblems/left/logos/Gra.png": 2096,
	"./amblems/left/logos/Hertha.png": 2097,
	"./amblems/left/logos/Huddersfield.png": 2098,
	"./amblems/left/logos/Inter.png": 2099,
	"./amblems/left/logos/Juventus.png": 2100,
	"./amblems/left/logos/Lazio.png": 2101,
	"./amblems/left/logos/Leg.png": 2102,
	"./amblems/left/logos/Leicester.png": 2103,
	"./amblems/left/logos/Lev.png": 2104,
	"./amblems/left/logos/Leverkusen.png": 2105,
	"./amblems/left/logos/Lille.png": 2106,
	"./amblems/left/logos/Liverpool.png": 2107,
	"./amblems/left/logos/Lyon.png": 2108,
	"./amblems/left/logos/Mal.png": 2109,
	"./amblems/left/logos/Manchester.png": 2110,
	"./amblems/left/logos/ManchesterCity.png": 2111,
	"./amblems/left/logos/Marseille.png": 2112,
	"./amblems/left/logos/Milan.png": 2113,
	"./amblems/left/logos/NewCastle.png": 2114,
	"./amblems/left/logos/Osa.png": 2115,
	"./amblems/left/logos/REAL MALLORCA.png": 2116,
	"./amblems/left/logos/REAL SOCIEDAD.png": 2117,
	"./amblems/left/logos/RealMadrid.png": 2118,
	"./amblems/left/logos/Reb.png": 2119,
	"./amblems/left/logos/Rem.png": 2120,
	"./amblems/left/logos/Rev.png": 2121,
	"./amblems/left/logos/Roma.png": 2122,
	"./amblems/left/logos/Schalke.png": 2123,
	"./amblems/left/logos/Sev.png": 2124,
	"./amblems/left/logos/Southampton.png": 2125,
	"./amblems/left/logos/StrokeCity.png": 2126,
	"./amblems/left/logos/SwanCity.png": 2127,
	"./amblems/left/logos/TottenhamHotspur.png": 2128,
	"./amblems/left/logos/Val.png": 2129,
	"./amblems/left/logos/Vil.png": 2130,
	"./amblems/left/logos/Watford.png": 2131,
	"./amblems/left/logos/WestHamUtd.png": 2132,
	"./amblems/right/France/Fake_Bordeaux.png": 2133,
	"./amblems/right/France/Fake_Lille.png": 2134,
	"./amblems/right/France/Fake_Lyon.png": 2135,
	"./amblems/right/France/Fake_Marseille.png": 2136,
	"./amblems/right/France/Fake_PSG.png": 2137,
	"./amblems/right/Germany/Fake_Bayern.png": 2138,
	"./amblems/right/Germany/Fake_Dortmund.png": 2139,
	"./amblems/right/Germany/Fake_Hertha.png": 2140,
	"./amblems/right/Germany/Fake_Leverkusen.png": 2141,
	"./amblems/right/Germany/Fake_Schalke.png": 2142,
	"./amblems/right/Italy/Fake_Inter.png": 2143,
	"./amblems/right/Italy/Fake_Juventus.png": 2144,
	"./amblems/right/Italy/Fake_Lazio.png": 2145,
	"./amblems/right/Italy/Fake_Milan.png": 2146,
	"./amblems/right/Italy/Fake_Roma.png": 2147,
	"./amblems/right/Spain/Fake_AtleticoBilbao.png": 2148,
	"./amblems/right/Spain/Fake_AtleticoMadrid.png": 2149,
	"./amblems/right/Spain/Fake_Barcelona.png": 2150,
	"./amblems/right/Spain/Fake_RealMadrid.png": 2151,
	"./amblems/right/Spain/Fake_Valencia.png": 2152,
	"./amblems/right/logos/ALAVES.png": 2153,
	"./amblems/right/logos/ATLETICO MADRID.png": 2154,
	"./amblems/right/logos/Arsenal.png": 2155,
	"./amblems/right/logos/AtleticoBilbao.png": 2156,
	"./amblems/right/logos/AtleticoMadrid.png": 2157,
	"./amblems/right/logos/BILBAO.png": 2158,
	"./amblems/right/logos/Barcelona.png": 2159,
	"./amblems/right/logos/Bayern.png": 2160,
	"./amblems/right/logos/Bordeaux.png": 2161,
	"./amblems/right/logos/Bournmouth.png": 2162,
	"./amblems/right/logos/BrightHoveAlbion.png": 2163,
	"./amblems/right/logos/Broomwich.png": 2164,
	"./amblems/right/logos/Burnley.png": 2165,
	"./amblems/right/logos/CELTA VIGO.png": 2166,
	"./amblems/right/logos/Chelsea.png": 2167,
	"./amblems/right/logos/CrystalPalace.png": 2168,
	"./amblems/right/logos/Dortmund.png": 2169,
	"./amblems/right/logos/EIBAR.png": 2170,
	"./amblems/right/logos/ESPANYOL.png": 2171,
	"./amblems/right/logos/Everton.png": 2172,
	"./amblems/right/logos/FakeAstonVilla.png": 2173,
	"./amblems/right/logos/FakeCardiffCity.png": 2174,
	"./amblems/right/logos/FakeFulham.png": 2175,
	"./amblems/right/logos/FakeNorwichCity.png": 2176,
	"./amblems/right/logos/FakeSheffield.png": 2177,
	"./amblems/right/logos/FakeWolverhampton.png": 2178,
	"./amblems/right/logos/Fake_Arsenal.png": 2179,
	"./amblems/right/logos/Fake_Bournmouth.png": 2180,
	"./amblems/right/logos/Fake_BrightHoveAlbion.png": 2181,
	"./amblems/right/logos/Fake_Broomwich.png": 2182,
	"./amblems/right/logos/Fake_Burnley.png": 2183,
	"./amblems/right/logos/Fake_Chelsea.png": 2184,
	"./amblems/right/logos/Fake_CrystalPalace.png": 2185,
	"./amblems/right/logos/Fake_Everton.png": 2186,
	"./amblems/right/logos/Fake_Huddersfield.png": 2187,
	"./amblems/right/logos/Fake_Leicester.png": 2188,
	"./amblems/right/logos/Fake_Liverpool.png": 2189,
	"./amblems/right/logos/Fake_Manchester.png": 2190,
	"./amblems/right/logos/Fake_ManchesterCity.png": 2191,
	"./amblems/right/logos/Fake_NewCastle.png": 2192,
	"./amblems/right/logos/Fake_Southampton.png": 2193,
	"./amblems/right/logos/Fake_StrokeCity.png": 2194,
	"./amblems/right/logos/Fake_SwanCity.png": 2195,
	"./amblems/right/logos/Fake_TottenhamHotspur.png": 2196,
	"./amblems/right/logos/Fake_Watford.png": 2197,
	"./amblems/right/logos/Fake_WestHamUtd.png": 2198,
	"./amblems/right/logos/GETAFE.png": 2199,
	"./amblems/right/logos/GRANADA.png": 2200,
	"./amblems/right/logos/Hertha.png": 2201,
	"./amblems/right/logos/Huddersfield.png": 2202,
	"./amblems/right/logos/Inter.png": 2203,
	"./amblems/right/logos/Juventus.png": 2204,
	"./amblems/right/logos/LEGANES.png": 2205,
	"./amblems/right/logos/LEVANTE.png": 2206,
	"./amblems/right/logos/Lazio.png": 2207,
	"./amblems/right/logos/Leicester.png": 2208,
	"./amblems/right/logos/Leverkusen.png": 2209,
	"./amblems/right/logos/Lille.png": 2210,
	"./amblems/right/logos/Liverpool.png": 2211,
	"./amblems/right/logos/Lyon.png": 2212,
	"./amblems/right/logos/Manchester.png": 2213,
	"./amblems/right/logos/ManchesterCity.png": 2214,
	"./amblems/right/logos/Marseille.png": 2215,
	"./amblems/right/logos/Milan.png": 2216,
	"./amblems/right/logos/NewCastle.png": 2217,
	"./amblems/right/logos/OSASUMA.png": 2218,
	"./amblems/right/logos/PSG.png": 2219,
	"./amblems/right/logos/REAL BETIS.png": 2220,
	"./amblems/right/logos/REAL MADRID.png": 2221,
	"./amblems/right/logos/REAL MALLORCA.png": 2222,
	"./amblems/right/logos/REAL SOCIEDAD.png": 2223,
	"./amblems/right/logos/REAL VALLADOLID.png": 2224,
	"./amblems/right/logos/RealMadrid.png": 2225,
	"./amblems/right/logos/Roma.png": 2226,
	"./amblems/right/logos/SEVILLA.png": 2227,
	"./amblems/right/logos/Schalke.png": 2228,
	"./amblems/right/logos/Southampton.png": 2229,
	"./amblems/right/logos/StrokeCity.png": 2230,
	"./amblems/right/logos/SwanCity.png": 2231,
	"./amblems/right/logos/TottenhamHotspur.png": 2232,
	"./amblems/right/logos/VALENCIA.png": 2233,
	"./amblems/right/logos/VILLARREAL.png": 2234,
	"./amblems/right/logos/Watford.png": 2235,
	"./amblems/right/logos/WestHamUtd.png": 2236,
	"./betting-virtualf-games-holder-bar.png": 2237,
	"./btn-background-black.png": 326,
	"./btn-background-green.png": 327,
	"./fast-choosen-bck.png": 328,
	"./games-table-odds-disabled.png": 180,
	"./games-table-odds-hover.png": 181,
	"./games-table-odds.png": 329,
	"./header-babaijebu.png": 330,
	"./jerseys/Black.png": 182,
	"./jerseys/Black_And_White.png": 2238,
	"./jerseys/Blue.png": 2239,
	"./jerseys/Green.png": 2240,
	"./jerseys/Orange.png": 2241,
	"./jerseys/Red.png": 183,
	"./jerseys/Red_And_White.png": 2242,
	"./jerseys/White.png": 2243,
	"./livescore.jpg": 184,
	"./next-bck.png": 139,
	"./odd-games-active.png": 140,
	"./odd-games.png": 185,
	"./standings-red-dress.png": 2244,
	"./ticket-vfl-bar.png": 331,
	"./vdh-progress.png": 332,
	"./video/VFL_logo_012.png": 2245,
	"./video/clubs/england/arsenal.png": 333,
	"./video/clubs/england/chelsea.png": 334,
	"./video/clubs/england/liverpool.png": 335,
	"./video/clubs/england/m-city.png": 336,
	"./video/clubs/england/m-united.png": 337,
	"./video/clubs/france/bordeaux.png": 338,
	"./video/clubs/france/lille.png": 339,
	"./video/clubs/france/lyon.png": 340,
	"./video/clubs/france/marseille.png": 341,
	"./video/clubs/france/psg.png": 342,
	"./video/clubs/germany/bayern.png": 343,
	"./video/clubs/germany/dortmund.png": 344,
	"./video/clubs/germany/hertha.png": 345,
	"./video/clubs/germany/leverkusen.png": 346,
	"./video/clubs/germany/schalke04.png": 347,
	"./video/clubs/italy/inter.png": 348,
	"./video/clubs/italy/juventus.png": 349,
	"./video/clubs/italy/lazio.png": 350,
	"./video/clubs/italy/milan.png": 351,
	"./video/clubs/italy/roma.png": 352,
	"./video/clubs/spain/atletico-bilbao.png": 353,
	"./video/clubs/spain/atletico-madrid.png": 354,
	"./video/clubs/spain/barcelona.png": 355,
	"./video/clubs/spain/real-madrid.png": 356,
	"./video/clubs/spain/valencia.png": 357,
	"./video/result-logo.png": 2246,
	"./video/result-score.png": 358,
	"./video/video-bck.png": 359,
	"./video/video-header-bck.png": 360,
	"./video/video-jackpot.png": 361,
	"./video/video-mega-jackpot.png": 362,
	"./video/virtualf-logo.png": 2247,
	"./video/vvb-body-bot.png": 363,
	"./video/vvb-body-top.png": 364,
	"./video/vvb-header.png": 365,
	"./virtualf-video.png": 2248
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2028;


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img \.(gif|png|jpe?g|svg)$/
// module id = 2028
// module chunks = 4